<template>
  <div class="home">
    <!-- 轮播图区域 -->
    <section class="hero-section">
      <b-carousel
        id="hero-carousel"
        v-model="slide"
        :interval="4000"
        indicators
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        class="hero-carousel2"
      >
        <b-carousel-slide
          img-src="/images/banner/banner1.svg"
        >
          <template #img>
            <img
              src="/images/banner/banner1.svg"
              alt="banner1"
              @click="goToProducts"
              style="height: 100%; width: 100%;"
            />
          </template>
        </b-carousel-slide>
        
        <b-carousel-slide
          img-src="/images/banner/banner2.svg"
        >
          <template #img>
            <img
              src="/images/banner/banner2.svg"
              alt="banner2"
              @click="goToProducts"
              style="height: 100%; width: 100%;"
            />
          </template>
        </b-carousel-slide>
        
        <b-carousel-slide
          img-src="/images/banner/banner3.svg"
        >
          <template #img>
            <img
              src="/images/banner/banner3.svg"
              alt="banner3"
              @click="goToAbout"
              style="height: 100%; width: 100%;"
            />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </section>

    <!-- 证书展示区域 -->
    <section class="certificates-section py-5 bg-light">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-12">
            <h2 class="section-title">资质证书</h2>
            <p class="section-subtitle text-muted">合规经营，值得信赖</p>
          </div>
        </div>
        
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-6 mb-4">
            <div class="certificate-card text-center p-5 h-100">
              <div class="certificate-image mb-4">
                <img src="/images/GR001.jpg" alt="营业执照" class="img-fluid certificate-img-large">
              </div>
              <h3 class="certificate-title">营业执照</h3>
            </div>
          </div>
          
          <div class="col-lg-6 col-md-6 mb-4">
            <div class="certificate-card text-center p-5 h-100">
              <div class="certificate-image mb-4">
                <img src="/images/GR002.jpg" alt="危险化学品经营许可证" class="img-fluid certificate-img-large">
              </div>
              <h3 class="certificate-title">危险化学品经营许可证</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司优势区域 -->
    <section class="advantages-section py-5">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-12">
            <h2 class="section-title">我们的优势</h2>
            <p class="section-subtitle text-muted">专业、可靠、高效的化工原料供应服务</p>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4" v-for="advantage in advantages" :key="advantage.id">
            <div class="advantage-card text-center p-4 h-100">
              <div class="advantage-icon mb-3">
                <b-icon :icon="advantage.icon" font-scale="3" variant="primary"></b-icon>
              </div>
              <h4>{{ advantage.title }}</h4>
              <p class="text-muted">{{ advantage.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据展示区域 -->
    <section class="stats-section py-5 bg-primary text-white">
      <div class="container">
        <div class="row text-center">
          <div class="col-lg-4 col-md-6 mb-4" v-for="stat in stats" :key="stat.id">
            <div class="stat-item">
              <h2 class="stat-number mb-2">{{ stat.number }}</h2>
              <p class="stat-label mb-0">{{ stat.label }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 热门产品区域 -->
    <section class="products-section py-5">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-12">
            <h2 class="section-title">热门产品</h2>
            <p class="section-subtitle text-muted">精选优质化工原料，满足您的各种需求</p>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-3 col-md-6 mb-4" v-for="product in featuredProducts" :key="product.id">
            <ProductCard :product="product" @show-details="showProductDetails" />
          </div>
        </div>
        
        <div class="text-center mt-4">
          <b-button variant="primary" size="lg" to="/products">
            查看更多产品
            <b-icon icon="arrow-right" class="ml-2"></b-icon>
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'Home',
  components: {
    ProductCard
  },
  data() {
    return {
      slide: 0,
      advantages: [
        {
          id: 1,
          icon: 'shield-check',
          title: '品质保证',
          description: '严格的质量控制体系，确保每一批产品都符合国家标准'
        },
        {
          id: 2,
          icon: 'truck',
          title: '快速配送',
          description: '完善的物流网络，确保产品及时安全送达客户手中'
        },
        {
          id: 3,
          icon: 'headset',
          title: '专业服务',
          description: '专业的技术团队，为您提供全方位的技术支持和咨询'
        },
        {
          id: 4,
          icon: 'award',
          title: '行业经验',
          description: '多年化工行业经验，深度了解客户需求和市场动态'
        },
        {
          id: 5,
          icon: 'people',
          title: '客户至上',
          description: '以客户需求为导向，提供个性化的产品解决方案'
        },
        {
          id: 6,
          icon: 'graph-up',
          title: '持续发展',
          description: '不断创新发展，为客户创造更大的价值和效益'
        }
      ],
      stats: [
        { id: 1, number: '2000', label: '成立年份' },
        { id: 2, number: '500+', label: '产品种类' },
        { id: 3, number: '1000+', label: '服务客户' }
      ]
    }
  },
  computed: {
    ...mapState(['products']),
    featuredProducts() {
      return this.products.slice(0, 4)
    }
  },
  methods: {
    ...mapActions(['fetchProducts']),
    
    showProductDetails(product) {
      // 跳转到产品页面并显示详情
      this.$router.push({ path: '/products', query: { showProduct: product.id } })
    },
    
    goToProducts() {
      // 跳转到产品中心
      this.$router.push('/products')
    },
    
    goToAbout() {
      // 跳转到关于我们
      this.$router.push('/about')
    }
  },
  async created() {
    await this.fetchProducts()
  }
}
</script>

<style scoped>
.hero-carousel2 {
  margin-top: 76px; /* 导航栏高度 */
}

.carousel-bg {
  width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.carousel-bg.clickable {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.carousel-bg.clickable:hover {
  transform: scale(1.02);
}

/* 轮播图控制按钮样式 - 减小宽度避免遮挡图片 */
.hero-carousel >>> .carousel-control-prev,
.hero-carousel >>> .carousel-control-next {
  width: 40px !important;
  height: 60px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.hero-carousel >>> .carousel-control-prev {
  left: 10px !important;
}

.hero-carousel >>> .carousel-control-next {
  right: 10px !important;
}

.hero-carousel >>> .carousel-control-prev:hover,
.hero-carousel >>> .carousel-control-next:hover {
  opacity: 1;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #2c5aa0;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.advantage-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.advantage-icon {
  color: #2c5aa0;
}

/* 证书展示区域样式 */
.certificates-section {
  background-color: #f8f9fa;
}

.certificate-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.certificate-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.certificate-image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.certificate-img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.certificate-img-large {
  max-width: 100%;
  max-height: 400px; /* Adjusted for two per row */
  object-fit: contain;
  transition: transform 0.3s ease;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.certificate-img:hover,
.certificate-img-large:hover {
  transform: scale(1.02);
}

.certificate-title {
  color: #2c5aa0;
  font-weight: 600;
  margin-bottom: 0;
}

.stats-section {
  background: linear-gradient(135deg, #2c5aa0 0%, #1e4080 100%);
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1.1rem;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
  
  .carousel-bg {
    height: 250px;
    background-size: contain;
    background-position: center;
    background-repeat: round;
  }
  
  /* 移动端证书展示适配 */
  .certificate-img,
  .certificate-img-large {
    max-height: 250px; /* Adjusted for two per row on medium screens */
  }
  
  .certificate-title {
    font-size: 1.1rem;
  }
  
  .certificates-section .col-lg-6 {
    margin-bottom: 2rem;
  }
  
  .certificate-card {
    padding: 2rem !important;
  }
}

@media (max-width: 576px) {
  .certificate-img,
  .certificate-img-large {
    max-height: 180px; /* Adjusted for two per row on small screens */
  }
  
  .certificate-title {
    font-size: 1rem;
  }
  
  .certificate-card {
    padding: 1.5rem !important;
  }
  
  .certificates-section .col-lg-6 {
    margin-bottom: 1.5rem;
  }
}
</style>